import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { ToastProvider } from './lib/useToast';
import { Login } from './screens/Login';
import { ChangePassword } from './screens/ChangePassword';
import { AppLayout } from './screens/AppLayout';
import type { ViewKey } from './nav/navModel';

function Protected({ children }: { children: React.ReactElement }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  // Clave temporal asignada por Gerencia: no se puede operar hasta cambiarla.
  if (user.must_change_password) return <Navigate to="/cambiar-clave" replace />;
  return children;
}

function PasswordRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <ChangePassword /> : <Navigate to="/login" replace />;
}

function ViewRoute() {
  const { view } = useParams();
  return <AppLayout view={(view ?? 'dashboard') as ViewKey} />;
}

/** Rutas de la aplicación (sin el enrutador, para poder montarlas en pruebas con un MemoryRouter). */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/cambiar-clave" element={<PasswordRoute />} />
      <Route
        path="/app/:view"
        element={
          <Protected>
            <ViewRoute />
          </Protected>
        }
      />
      <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <AppRoutes />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
